module.exports = __webpack_public_path__ + "static/media/stepDone.6a0d7b9b.svg";